import { ArrowUpRight, CalendarDays, Mail } from "lucide-react";

function ChannelBorder({ highlighted = false }) {
  return (
    <span
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 rounded-2xl"
      style={{
        padding: "1.5px",
        background:
          "linear-gradient(135deg,#6366F1 0%,#A855F7 50%,#EC4899 100%)",
        WebkitMask:
          "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
        WebkitMaskComposite: "xor",
        maskComposite: "exclude",
        opacity: highlighted ? 1 : 0.35,
      }}
    />
  );
}

export default function ChannelSelector() {
  const scrollToForm = (e) => {
    e.preventDefault();
    const form = document.getElementById("booking-form");
    if (form) form.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div data-testid="channel-selector" className="mb-10 md:mb-14">
      <div className="text-center md:text-left mb-6 md:mb-8">
        <h3 className="font-display text-2xl md:text-3xl tracking-tight font-medium text-[#0B1027] leading-tight">
          Comment souhaitez-vous{" "}
          <em className="not-italic italic font-light text-aurora">
            démarrer ?
          </em>
        </h3>
        <p className="mt-2 text-[#0F172A]/60 text-sm md:text-base">
          Choisissez le canal qui vous met à l'aise. Aucune mauvaise réponse.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4">
        {/* WhatsApp */}
        <a
          href="https://wa.me/32498979847?text=Bonjour%20David%2C%20je%20d%C3%A9couvre%20Numedia%20et%20j%27aimerais%20discuter%20d%27un%20projet."
          target="_blank"
          rel="noopener noreferrer"
          data-testid="channel-whatsapp"
          className="group relative rounded-2xl bg-white p-5 md:p-6 shadow-tactile hover:shadow-tactile-lg hover-lift transition-all block"
        >
          <ChannelBorder />
          <div className="relative">
            <div className="flex items-center justify-center h-12 w-12 rounded-2xl bg-[#25D366]/10 mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="#25D366" aria-hidden="true">
                <path d="M17.6 6.32a7.85 7.85 0 0 0-11.13 0 7.87 7.87 0 0 0-1.28 9.5L4 20l4.28-1.12a7.87 7.87 0 0 0 3.76.96h.01a7.86 7.86 0 0 0 5.56-13.52M12.05 18.5a6.53 6.53 0 0 1-3.33-.9l-.24-.15-2.5.66.67-2.45-.16-.25a6.55 6.55 0 0 1 5.56-10.02 6.55 6.55 0 0 1 4.63 1.92 6.55 6.55 0 0 1 1.92 4.63 6.56 6.56 0 0 1-6.55 6.55m3.6-4.9c-.2-.1-1.17-.58-1.35-.64-.18-.07-.31-.1-.44.1s-.5.64-.62.77c-.11.13-.23.15-.42.05-.2-.1-.83-.31-1.58-.98a5.9 5.9 0 0 1-1.09-1.36c-.11-.2-.01-.3.09-.4.09-.08.2-.23.3-.34.1-.11.13-.19.2-.32.06-.13.03-.24-.02-.34-.05-.1-.44-1.07-.61-1.46-.16-.39-.32-.34-.44-.34-.11 0-.24-.02-.37-.02s-.34.05-.52.24c-.18.2-.68.66-.68 1.62s.7 1.88.8 2.01c.09.13 1.37 2.1 3.32 2.94.47.2.83.32 1.11.42.47.15.9.13 1.24.08.38-.06 1.17-.48 1.34-.94.17-.47.17-.87.12-.94-.05-.08-.18-.13-.38-.23z"/>
              </svg>
            </div>
            <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-emerald-600 mb-1">
              Réponse &lt; 2 h
            </div>
            <h4 className="font-display text-lg md:text-xl text-[#0B1027] mb-1.5">
              WhatsApp direct
            </h4>
            <p className="text-xs md:text-sm text-[#0F172A]/60 leading-relaxed">
              Un message rapide, une réponse humaine dans la journée.
            </p>
            <div className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-[#6366F1] group-hover:text-[#A855F7] transition-colors">
              Écrire à David
              <ArrowUpRight size={14} strokeWidth={2.2} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </div>
          </div>
        </a>

        {/* Calendar (scroll to form) */}
        <a
          href="#booking-form"
          onClick={scrollToForm}
          data-testid="channel-calendar"
          className="group relative rounded-2xl bg-white p-5 md:p-6 shadow-tactile hover:shadow-tactile-lg hover-lift transition-all block"
        >
          <ChannelBorder highlighted />
          <div className="relative">
            <div className="flex items-center justify-center h-12 w-12 rounded-2xl mb-4"
              style={{
                background: "linear-gradient(135deg,#6366F1 0%,#A855F7 50%,#EC4899 100%)",
              }}
            >
              <CalendarDays size={22} className="text-white" strokeWidth={2} />
            </div>
            <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#A855F7] mb-1">
              Appel de 30 min
            </div>
            <h4 className="font-display text-lg md:text-xl text-[#0B1027] mb-1.5">
              Réserver un créneau
            </h4>
            <p className="text-xs md:text-sm text-[#0F172A]/60 leading-relaxed">
              Choisissez date et heure — visio ou téléphone.
            </p>
            <div className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-[#6366F1] group-hover:text-[#A855F7] transition-colors">
              Voir le calendrier
              <ArrowUpRight size={14} strokeWidth={2.2} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </div>
          </div>
        </a>

        {/* Email */}
        <a
          href="mailto:contact@numedia.be?subject=Projet%20Numedia"
          data-testid="channel-email"
          className="group relative rounded-2xl bg-white p-5 md:p-6 shadow-tactile hover:shadow-tactile-lg hover-lift transition-all block"
        >
          <ChannelBorder />
          <div className="relative">
            <div className="flex items-center justify-center h-12 w-12 rounded-2xl bg-[#6366F1]/10 mb-4">
              <Mail size={22} className="text-[#6366F1]" strokeWidth={2} />
            </div>
            <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#6366F1] mb-1">
              Réponse &lt; 24 h
            </div>
            <h4 className="font-display text-lg md:text-xl text-[#0B1027] mb-1.5">
              Envoyer un email
            </h4>
            <p className="text-xs md:text-sm text-[#0F172A]/60 leading-relaxed">
              Un mot posé, tranquille, quand vous voulez.
            </p>
            <div className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-[#6366F1] group-hover:text-[#A855F7] transition-colors">
              contact@numedia.be
              <ArrowUpRight size={14} strokeWidth={2.2} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </div>
          </div>
        </a>
      </div>

      {/* Reassurance strip */}
      <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-1.5 text-[11px] text-[#0F172A]/50">
        <span>✓ Sans engagement</span>
        <span>✓ Réponse humaine (pas de bot)</span>
        <span>✓ Zéro sollicitation commerciale</span>
      </div>
    </div>
  );
}
